import React from 'react'

const Tab = ({ imgLink, isActive, onClick, children, classes, disabled }) => {
  const handleClick = () => {
    if (!disabled) {
      onClick()
    }
  }

  return (
    <div
      data-active={isActive ? 'true' : undefined}
      className={`flex items-center gap-2 px-3 py-3 border-b-2 -mb-px transition-colors max-w-max
       ${isActive ? "border-primary-main" : "border-transparent"}
       ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
      onClick={handleClick}>
      <div className='min-w-[16px] flex justify-center items-center'>{React.cloneElement(imgLink, { style: { opacity: disabled ? 0.5 : 1 } })}</div>
      <span
        className={`text-[14px] flex justify-center items-center ${classes} ${isActive ? 'font-semibold text-text-primary' : 'text-text-secondary'} ${disabled ? "text-text-secondary" : ""}`}>{children}</span>
    </div>
  )
}

export default Tab
